$(document).ready(function () {
    $('.nav-tabs [data-toggle="tab"]').on('show.bs.tab', function ($ev) {
        $('[data-tab-content="' + $($ev.target).attr('aria-controls') + '"]').removeClass('d-none');
        $('[data-tab-content="' + $($ev.relatedTarget).attr('aria-controls') + '"]').addClass('d-none');
    });

    $('[role="tablist"] a[data-toggle]').on('shown.bs.tab', function (event) {
        if (window.location.hash !== $(event.target).attr('href')) {
            history.pushState(null, null, $(event.target).attr('href'));
        }
    });

    function locationHashChanged(e) {
        console.log(location.hash);
        console.log(e.oldURL, e.newURL);
        var tabLink = $('[role="tablist"] [data-toggle][href="' + window.location.hash + '"]');
        if (tabLink.length === 1) {
            tabLink.trigger('click');
        } else {
            $($('[role="tablist"] [data-toggle]')[0]).trigger('click');
        }
    }

    function loadTabContents(tabLink) {
        var targetTab = $('[data-tab-content="' + tabLink.attr('aria-controls') + '"]');
        var targetSubnav = $('#' + tabLink.attr('aria-controls'));
        if (targetSubnav.is('.pane-empty')) {
            $('#nav-tabContent').addClass('hide-nav');
        } else {
            $('#nav-tabContent').removeClass('hide-nav');
        }
        targetTab.trigger('tab-loaded');
        $.each(targetTab.find('[data-tab-load]'), function () {
            connection.loadPart($(this));
        });
    }

    // tab hash state
    if (window.location.hash) {
        var tabLink = $('[role="tablist"] [data-toggle][href="' + window.location.hash + '"]');
        if (tabLink.length === 1) {
            tabLink.trigger('click');
            loadTabContents(tabLink);
        }
    }

    window.onhashchange = locationHashChanged;
    // end: tab hash state

    $('[role="tablist"] a[data-toggle]').on('show.bs.tab', function (event) {
        var targetTab = $('[data-tab-content="' + $(event.target).attr('aria-controls') + '"]');
        $.each(targetTab.find('[data-tab-load]'), function () {
            $(this).html('');
        });
    });
    $('[role="tablist"] a[data-toggle]').on('shown.bs.tab', function (event) {
        loadTabContents($(event.target));
    });

    var ribbonContainers = $('.ribbon-nav-scroll');
    $.each(ribbonContainers, (i, el) => {
        var ribbonContainer = $(el);
        var ribbonBody = ribbonContainer.find('.panel-body');
        var $scrollRightBtn = $('<div class="nav-scroll nav-scroll-right" style=""><i class="bi bi-chevron-right"></i></div>');
        ribbonContainer.append($scrollRightBtn);
        var $scrollLeftBtn = $('<div class="nav-scroll nav-scroll-left" style=""><i class="bi bi-chevron-left"></i></div>');
        ribbonContainer.append($scrollLeftBtn);

        $scrollRightBtn.click(ev => {
            var navInfo = getRibbonNavInfo(ribbonContainer, ribbonBody);
            var newScroll = Math.max(navInfo.currentScroll - 150, navInfo.maxScroll);
            // console.log(navInfo, newScroll);

            // ribbonBody.css('transform', `translateX(${newScroll}px)`);
            ribbonBody.css('margin-left', `${newScroll}px`);
            ribbonContainer.attr('data-scroll-pos', newScroll <= navInfo.maxScroll ? 'end' : 'center');
            return false;
        });

        $scrollLeftBtn.click(ev => {
            var navInfo = getRibbonNavInfo(ribbonContainer, ribbonBody);
            var newScroll = Math.min(navInfo.currentScroll + 150, 0);
            // console.log(navInfo, newScroll);

            // ribbonBody.css('transform', `translateX(${newScroll}px)`);
            ribbonBody.css('margin-left', `${newScroll}px`);
            ribbonContainer.attr('data-scroll-pos', newScroll === 0 ? 'start' : 'center');
            return false;
        });

        ribbonContainer.addClass('position-relative');
        ribbonContainer.attr('data-scroll-pos', 'none');
    });

    function getRibbonNavInfo(ribbonContainer, ribbonBody) {
        var ribbonBodyWidth = 60; // padding left and right for arrows
        ribbonBody.find('>*:visible').each(function(index) {
            ribbonBodyWidth += parseInt($(this).outerWidth(), 10);
        });

        //var transformValue = window.getComputedStyle(ribbonBody[0]).getPropertyValue('transform');
        //var currentScroll = transformValue === 'none' ? 0 : parseInt(transformValue.split(",")[4]);
        var currentScroll = parseInt(window.getComputedStyle(ribbonBody[0]).getPropertyValue('margin-left'));
        console.log(currentScroll);
        var maxScroll = -(ribbonBodyWidth - parseInt(ribbonContainer.width()));

        return {
            containerWidth: parseInt(ribbonContainer.outerWidth()),
            bodyWidth: ribbonBodyWidth,
            maxScroll: maxScroll,
            minScroll: 0,
            currentScroll: currentScroll,
        };
    }

    $(window).resize(function() {
        $.each(ribbonContainers, (i, el) => {
            var ribbonContainer = $(el);
            var ribbonBody = ribbonContainer.find('.panel-body');
            var navInfo = getRibbonNavInfo(ribbonContainer, ribbonBody);

            if (navInfo.bodyWidth > navInfo.containerWidth) {
                if (ribbonContainer.attr('data-scroll-pos') === 'none') {
                    ribbonContainer.attr('data-scroll-pos', 'start');
                }
            } else {
                // ribbonBody.css('transform', `translateX(0px)`);
                ribbonBody.css('margin-left', `0px`);
                ribbonContainer.attr('data-scroll-pos', 'none');
            }
        });

    }).resize();
});
